import React, { useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import '../assets/css/ActionExpandableButtons.css';
import { TextLink2 } from './common/GlobalElements/Typography';

function useMediaQuery(query) {
    const [matches, setMatches] = useState(
        window.matchMedia(query).matches
    );

    useEffect(() => {
        const media = window.matchMedia(query);

        const listener = () => setMatches(media.matches);
        media.addEventListener("change", listener);

        return () => media.removeEventListener("change", listener);
    }, [query]);

    return matches;
}

/**
 * Reusable component for left side bars that has to be expandable.
 * This contains 2 buttons (the left button would be a link (back)),
 * the right button would be a burger menu if unexpanded, but close button when unexpanded.
 * It's responsive for mobile view as well.
 * @param {object} param { label - string, link - string }
 * @returns Component
 */
function ActionExpandableButtons({ label, link }) {
    const [isSidebarHidden, setIsSidebarHidden] = useState(false);
    const isSmallScreen = useMediaQuery("(max-width: 767px)");
    const isMediumScreen = useMediaQuery("(max-width: 991px)");

    // Detect if sidebar is closed:
    useEffect(() => {
        const hasClass = document.body.classList.contains("hide-subject-sidebar");
        if (isMediumScreen && !isSmallScreen) {
            // If medium screen, don't show the bar:
            document.body.classList.remove("hide-subject-sidebar");
            setIsSidebarHidden(true);
        } else {
            setIsSidebarHidden(hasClass);
        }
        console.log("matches", { isSmallScreen, isMediumScreen });
    }, [isSmallScreen, isMediumScreen]);

    const handleSideBar = () => {
        document.body.classList.toggle("hide-subject-sidebar");
    };
    return (
        <div class="action-buttons">
            <TextLink2 to={link}>
                <i className="fal fa-angle-left"></i>{label}
            </TextLink2>
            <button className="custom-btn-sidebar" onClick={handleSideBar} />
        </div>
    );
}

export default ActionExpandableButtons;
